import { ErrorMessage } from 'nhsuk-react-components';

interface CohortRulesErrorsProps {
    errors: string;
}

// eslint-disable-next-line import/prefer-default-export
export function CohortRulesErrors({ errors }: CohortRulesErrorsProps) {
  return (
    <div data-testid="cohort-rules-errors">
      <ErrorMessage>These rules use cohorts that:</ErrorMessage>
      <ErrorMessage>
        <ul>
          {errors.split(',').map((error) => (
            <li key={error}>{error.trim()}</li>
          ))}
        </ul>
      </ErrorMessage>
      <ErrorMessage>
        You need to either add this cohort or remove the rules that include
        this cohort.
      </ErrorMessage>
    </div>
  );
}
